import { useLocation } from "react-router-dom"
import { Settings, Plus, BarChart3 } from "lucide-react"
import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { ROUTES } from "@/constants/routes"
import { PAGE_TITLES } from "@/constants/constants"

interface PageHeaderContentProps {
  campaignCount?: number
}

export function PageHeaderContent({ campaignCount }: PageHeaderContentProps) {
  const location = useLocation()

  // Campaign Management page header
  if (location.pathname === ROUTES.CAMPAIGN_MANAGEMENT) {
    return (
      <div className="flex flex-1 items-center justify-between ml-4">
        <div className="flex items-center space-x-3">
          <div className="p-2 bg-primary/10 rounded-lg">
            <Settings className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h1 className="text-xl font-semibold text-foreground">
              {PAGE_TITLES.CAMPAIGN_MANAGEMENT}
            </h1>
            <p className="text-sm text-muted-foreground">
              Create, manage, and track your engagement campaigns
            </p>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          {campaignCount !== undefined && (
            <div className="flex items-center space-x-2 text-sm text-muted-foreground bg-card px-3 py-1.5 rounded-lg border border-border">
              <BarChart3 className="h-4 w-4" />
              <span className="font-medium">
                {campaignCount} {campaignCount === 1 ? 'campaign' : 'campaigns'}
              </span>
            </div>
          )}
          <Link to={ROUTES.CAMPAIGN_CREATE}>
            <Button className="bg-primary hover:bg-primary/90 text-primary-foreground shadow-md hover:shadow-lg transition-all duration-200">
              <Plus className="h-4 w-4 mr-2" />
              New Campaign
            </Button>
          </Link>
        </div>
      </div>
    )
  }

  return null
}
